export enum Paths {
  Landing = "/",
  CollaboratorInitial = "/home",
  CompanyList = "/companies",
  CompanyDetail = "/companyDetail",
  RegisterCompany = "/company",
  UnitList = "/units",
  RegisterUnit = "/unitRegister",
  UserRole = "/userRole",
  UserRoleEditProfile = '/userRoles/EditProfile',
  CareLineList = "/careLines",
  RegisterCareLine = "/registerCareLine",
  OccupationalHealthList = "/occupationalHealthList",
  OccupationalHealthRegister = "/occupationalHealthRegister",
  UpdateUserInfo = "/updateUserInfo",
  ConfirmUserInfo = "/confirmUserInfo",
  InformationComplementary = "/informationsComplementary",
  ChangePassword = "/changePassword",
  OMSQuestionnaire = "/questionarioOMS",
  HMVQuestionnaire = "/questionarioHMV",
  FileImport = "/fileImport",
  RelationshipGHE = "/relationshipGhe",
  AgendaList = "/agendaList",
  CriarAgenda = "/criarAgenda",
  AgendaPreviewDia = "/agendaPreviewDia",
  Agendas = "/agendas",
  AgendasMes = "/agendasMes",
  AgendaDias = "/agendaDia",
  Scheduling = "/agendamento",
  DetailScheduling = "/agendamento/detalhes",
  exams = "/exames",
  MeusPeriodicos = '/meusPeriodicos',
  MinhaLinhaCuidado = '/minhaLinhaCuidado',
  PainelAtendimento = '/atendimento',
  Prontuario = '/prontuario',
  RegistroAtendimento = '/registroAtendimento',
  PainelConsulta = '/consultas',
  AtribuirLinhaCuidado = '/prontuario/atribuirLinhaCuidado',
  DetalharLinhaCuidado = '/prontuario/detalharLinhaCuidado',
  RegistrarExame = '/prontuario/registrarExame',
  RegistrarAlergia = '/prontuario/registrarAlergia',
  ProntuarioPaciente = '/prontuarioPaciente',
  CentralAgendamento = '/centralAgendamento',
  VitalSignList = "/vitalSigns",
  VitalSignRegister = "/vitalSignRegister",
  MeusPacientes = "/meusPacientes",
  PainelNavegacao = "/painelNavegacao",
  AcompanhamentoNavegacao = "/acompanhamentoNavegacao/:id",
  ReaplicacaoQuestionario = "/reaplicacaoQuestionario",
}

